import { render } from "./MsMenuButton.vue?vue&type=template&id=6e413cb8&scoped=true"
import script from "./MsMenuButton.vue?vue&type=script&lang=js"
export * from "./MsMenuButton.vue?vue&type=script&lang=js"

import "./MsMenuButton.vue?vue&type=style&index=0&id=6e413cb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e413cb8"]])

export default __exports__